<template>
  <div>
    <footer class="w-full grid-cols-3 place-items-center hidden md:grid px-10 py-8">
      <div id="footerLeft" class="justify-self-start">
        <template v-if="!showFooter && couldNavigatePrev">
          <router-link to="/1" class="flex items-center"
            ><ph-arrow-left class="inline-block mr-1" />
            <span>{{ textSnippets.back_to_start }}</span>
          </router-link>
        </template>
      </div>
      <div class="col-start-2 grid grid-cols-2 gap-4">
        <a :href="urls.help ?? '#'" target="_blank" class="md:hidden">{{ textSnippets.help }}</a>
        <a :href="urls.data_protection ?? '#'" target="_blank" class="md:hidden">{{ textSnippets.data_protection }}</a>
      </div>
      <div id="footerRight" class="justify-self-end grid grid-cols-2 gap-4">
        <a :href="urls.help ?? '#'" target="_blank" class="hidden md:inline-block">{{ textSnippets.help }}</a>
        <a :href="urls.data_protection ?? '#'" target="_blank" class="hidden md:inline-block">{{
          textSnippets.data_protection
        }}</a>
      </div>
    </footer>
    <footer class="w-full py-4 px-8 md:hidden">
      <!-- mobile footer -->
      <div id="footerRight">
        <module-navigation isMobile />
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useMainStore } from '@/store/main'
import ModuleNavigation from '@/components/module/ModuleNavigation.vue'
import { getNavigationConditions } from '@/composables/navigationConditions'
import { PhArrowLeft } from '@dnlsndr/vue-phosphor-icons'

export default defineComponent({
  components: {
    ModuleNavigation,
  },

  setup() {
    /**
     * register store
     */
    const store = useMainStore()

    /**
     * @return {Language} textSnippets
     */
    const textSnippets = computed(() => store.snippets)

    /**
     * @return {Urls} urls
     */
    const urls = computed(() => store.urls)

    const { showFooter, couldNavigatePrev } = getNavigationConditions()

    return {
      textSnippets,
      urls,
      showFooter,
      couldNavigatePrev,
      PhArrowLeft,
    }
  },
})
</script>

<style scoped></style>
